module.exports = __webpack_public_path__ + "static/media/inbound.67d1cc34.png";